import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { decodeHtmlTextMessage } from '../utils';

type alertType = 'success' | 'info' | 'warn' | 'error' | 'notification';

@Injectable({
	providedIn: 'root',
})
export class AlertService {
	constructor(private readonly messageService: MessageService) {}

	public success(summary: string, detail: string): void {
		this.alert('success', summary, detail);
	}

	public error(summary: string, detail: string): void {
		this.alert('error', summary, detail);
	}

	public info(summary: string, detail: string): void {
		this.alert('info', summary, detail);
	}

	public warn(summary: string, detail: string): void {
		this.alert('warn', summary, detail);
	}

	public notification(summary: string, detail: string): void {
		this.alert('notification', summary, detail);
	}

	private alert(severity: alertType, summary: string, detail: string): void {
		if (!summary) {
			summary = 'Error!';
		}

		if (!detail) {
			detail = 'Error has occurred.';
		} else {
			detail = decodeHtmlTextMessage(detail);
		}

		this.messageService.add({ severity, summary, detail, life: 5000 });
	}
}
